import { useAtom } from 'jotai';
import { useCallback } from 'react';
import {
  isAdminAtom,
  adminCheckInProgressAtom,
  userEmailAtom,
  accessTokenAtom,
  isAuthenticatedAtom,
} from '../atoms/authAtom';
import { checkIsAdmin } from '../services/admin';

export interface UseAdminReturn {
  isAdmin: boolean;
  checkInProgress: boolean;
  userEmail: string | null;
  checkAdminStatus: () => Promise<void>;
}

export const useAdmin = (): UseAdminReturn => {
  const [isAdmin, setIsAdmin] = useAtom(isAdminAtom);
  const [checkInProgress, setCheckInProgress] = useAtom(adminCheckInProgressAtom);
  const [userEmail] = useAtom(userEmailAtom);
  const [accessToken] = useAtom(accessTokenAtom);
  const [isAuthenticated] = useAtom(isAuthenticatedAtom);

  const checkAdminStatus = useCallback(async () => {
    if (!accessToken || !isAuthenticated) {
      setIsAdmin(false);
      return;
    }

    setCheckInProgress(true);
    try {
      const adminStatus = await checkIsAdmin(accessToken);
      setIsAdmin(adminStatus);
    } catch (error) {
      console.error('Failed to check admin status:', error);
      setIsAdmin(false);
    } finally {
      setCheckInProgress(false);
    }
  }, [accessToken, isAuthenticated, setIsAdmin, setCheckInProgress]);

  return {
    isAdmin,
    checkInProgress,
    userEmail,
    checkAdminStatus,
  };
};
